import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
    {path: 'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule)},
    {path: 'homepage', loadChildren: () => import('./views/pages/homepage/homepage.module').then(m => m.HomepageModule)},
    {path: 'privacy-policy', loadChildren: () => import('./views/pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)},
    {path: 'terms-and-conditions', loadChildren: () => import('./views/pages/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)},
    {path: '', loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)},
    {path: '**', redirectTo: 'error/403', pathMatch: 'full'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            anchorScrolling: 'enabled'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
